/* GLUNDER jul 2026: debounce op aantal-wijziging in de winkelwagen.
   Voorkomt race condition bij snel klikken op +/-. */
(function () {
  var timers = new WeakMap();

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.cart-quantity .quantity__input')) return;
    if (event.detail && event.detail.debounced) return;

    event.stopImmediatePropagation();

    clearTimeout(timers.get(input));
    timers.set(input, setTimeout(function () {
      input.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        detail: { debounced: true }
      }));
    }, 500));
  }, true);
})();